import { render, staticRenderFns } from "./IssueTurnOutNum.vue?vue&type=template&id=ffa8df0c&scoped=true"
import script from "./IssueTurnOutNum.vue?vue&type=script&lang=js"
export * from "./IssueTurnOutNum.vue?vue&type=script&lang=js"
import style0 from "./IssueTurnOutNum.vue?vue&type=style&index=0&id=ffa8df0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa8df0c",
  null
  
)

export default component.exports